import { sagas as dataSagas } from './data';
import { sagas as uiSagas } from './ui';
import { sagas as configSagas } from './config';
import { sagas as sharingSagas } from './sharing';
import { sagas as tempSagas } from './tempDashboard';
import { sagas as dashboardSagas } from './dashboard';
import { sagas as requestSagas } from './request';

export default [
  ...dataSagas,
  ...configSagas,
  ...uiSagas,
  ...sharingSagas,
  ...tempSagas,
  ...dashboardSagas,
  ...requestSagas,
];
